import { watch } from 'vue';

import { useSseStore } from '#ui-shared/stores/sse-store';

/**
 * Runs the callback after the SSE stream reconnects, because missed events aren't replayed.
 */
export function useSseReconnect(onReconnect: () => void | Promise<void>): void {
  const sseStore = useSseStore();

  // Every connection starts with a new session ID, also when the native layer owns the stream.
  watch(
    () => sseStore.SSE_SESSION_ID,
    (sessionId, previousSessionId) => {
      if (
        sessionId === undefined
        || previousSessionId === undefined
        || sessionId === previousSessionId
      ) {
        return;
      }

      void Promise.resolve()
        .then(onReconnect)
        .catch((error: unknown) => {
          console.error('SSE reconnect handler failed:', error);
        });
    },
  );
}
